"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteringListStyleName = exports.EllipsedStyleName = exports.ListStyleName = exports.ListIsActiveClass = void 0;
var tslib_1 = require("tslib");
// tslint:disable:max-line-length
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Colors_1 = require("../../styles/Colors");
var Flexbox_1 = require("../../styles/Flexbox");
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var TabStyles_1 = require("../../styles/TabStyles");
var TextEllipsis_1 = require("../../styles/TextEllipsis");
var MenuItemWidget_1 = require("../MenuItemWidget");
var Colors = TabStyles_1.TabStyles.Colors, Opacity = TabStyles_1.TabStyles.Opacity, Sizing = TabStyles_1.TabStyles.Sizing, Spacing = TabStyles_1.TabStyles.Spacing, Typography = TabStyles_1.TabStyles.Typography;
var InternalIconPadding = 1; // svg includes 1px of padding
exports.ListIsActiveClass = 'listIsActive';
exports.ListStyleName = TypeStyle.style(PreventUserSelect_1.PreventUserSelect, {
    boxSizing: 'border-box',
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    lineHeight: 'normal',
    overflowY: 'auto',
    padding: Spacing.DefaultSpace,
    '-webkit-overflow-scrolling': 'touch',
    $nest: (_a = {
            '&:focus, & :focus': { outline: 'none' },
            '&::-moz-focus-inner, & ::-moz-focus-inner': { $unique: true, border: 'none' },
            '& [role="separator"]': {
                background: Colors.F3,
                height: 1,
                margin: '9.5px 0',
            },
            '& [role="group"] > :first-child': tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, Flexbox_1.AlignItemsCenter), Flexbox_1.DisplayFlex), { fontWeight: 'bold', minHeight: Sizing.ListRowHeight })
        },
        // List doesn't use focus-visible because it's in a dropdown or combobox the vast majority of cases
        _a["&:focus [role=\"option\"][aria-selected=\"true\"], &." + exports.ListIsActiveClass + " [role=\"option\"][aria-selected=\"true\"]"] = {
            backgroundColor: Colors.F3,
        },
        _a["&:focus [role=\"option\"][aria-selected=\"true\"][aria-disabled=\"true\"], &." + exports.ListIsActiveClass + " [role=\"option\"][aria-selected=\"true\"][aria-disabled=\"true\"]"] = {
            backgroundColor: '#b7b7b7',
        },
        _a['& [role="option"]'] = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, Flexbox_1.AlignItemsCenter), Flexbox_1.DisplayFlex), { backgroundRepeat: 'no-repeat', backgroundPosition: Spacing.DefaultSpace - InternalIconPadding + "px center", minHeight: Sizing.ListRowHeight, paddingLeft: MenuItemWidget_1.MenuItemCheck.size - InternalIconPadding + (Spacing.DefaultSpace * 2), paddingRight: Spacing.DefaultSpace, $nest: {
                '&[aria-checked="true"]': { backgroundImage: "url('" + MenuItemWidget_1.MenuItemCheck(Colors_1.IconFillColors.Hover) + "')" },
                '&:hover': {
                    backgroundColor: Colors.F2,
                },
                '&:active': {
                    backgroundColor: Colors.F3,
                },
                '&[aria-disabled="true"]': {
                    backgroundColor: 'transparent',
                    opacity: Opacity.Disabled,
                },
            } }),
        _a)
});
exports.EllipsedStyleName = TypeStyle.style(Flexbox_1.FlexGrow1, TextEllipsis_1.TextEllipsis);
exports.FilteringListStyleName = TypeStyle.style(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, Flexbox_1.DisplayFlex), Flexbox_1.FlexDirectionColumn), { boxSizing: 'border-box', lineHeight: 'normal', $nest: {
        '&.reverse': tslib_1.__assign({}, Flexbox_1.FlexDirectionColumnReverse),
    } }));
//# sourceMappingURL=ListStyles.js.map